import { TableBody, TableHead, TableRow } from '@mui/material';
import { NsnReport } from '@physna/core/domain/nsn-report/nsn-report';
import { StyledHeaderCell, StyledTable, StyledTableCell, StyledTableRow } from './NsnTable';

export const TechnicalCharacteristicsTable = ({
  technicalCharacteristics,
}: Pick<NsnReport, 'technicalCharacteristics'>) => {
  return (
    <StyledTable size='small'>
      <TableHead>
        <TableRow>
          <StyledHeaderCell>MRC</StyledHeaderCell>
          <StyledHeaderCell>Characteristic</StyledHeaderCell>
          <StyledHeaderCell>Value</StyledHeaderCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {technicalCharacteristics.map((characteristic, index) => (
          <StyledTableRow key={`technical-${characteristic.key}-${index}`}>
            <StyledTableCell>{characteristic.mrc}</StyledTableCell>
            <StyledTableCell>{characteristic.key}</StyledTableCell>
            <StyledTableCell>{characteristic.value}</StyledTableCell>
          </StyledTableRow>
        ))}
      </TableBody>
    </StyledTable>
  );
};
